export const DATE_FORMAT = {
  DDMMYY_FULL: 'DD MMM yyyy - hh:mm A', // => 02 Jul 2024 - 11:49 AM
  DDMMYY: 'DD MMM YYYY', // => 02 Jul 2024
  yyyyMMDD: 'yyyy-MM-DD', // => 2025-01-01 when referring to actual calendar dates (e.g., for logs, database records)
  YYYYMMDD: 'YYYY-MM-DD', // => 2024-12-31 when working with week-based reporting, fiscal year calculations, or ISO-8601 compliance
}
